// types
import { ThemeMode } from 'types/config';
import { PaletteThemeProps } from 'types/theme';
import { generateColorGradient, generateSecondaryGradient, generateStatusColors } from 'utils/colorUtils';

// ==============================|| PRESET THEME - TENANT DYNAMIC ||============================== //

/**
 * @param mode
 * @param primaryColor
 * @param secondaryColor
 * @returns
 */
const TenantDynamic = (
  mode: ThemeMode,
  primaryColor: string = '#3363FF',
  secondaryColor?: string
): PaletteThemeProps => {
  const contrastText = '#fff';
  const isDark = mode === ThemeMode.DARK;

  // Gera gradiente baseado na cor primária do tenant
  const primaryColors = generateColorGradient(primaryColor, isDark);

  // Gera gradiente secundário baseado na cor secundária ou primária
  const baseForSecondary = secondaryColor || primaryColor;
  const secondaryColors = generateSecondaryGradient(baseForSecondary, isDark);

  // Gera cores de status harmoniosas com a cor primária
  const statusColors = generateStatusColors(primaryColor, isDark);

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      500: secondaryColors[5]!,
      main: secondaryColors[6],
      dark: secondaryColors[7],
      800: secondaryColors[8],
      darker: secondaryColors[9],
      contrastText
    },
    error: {
      lighter: statusColors.error.lighter,
      light: statusColors.error.light,
      main: statusColors.error.main,
      dark: statusColors.error.dark,
      darker: statusColors.error.darker,
      contrastText
    },
    warning: {
      lighter: statusColors.warning.lighter,
      light: statusColors.warning.light,
      main: statusColors.warning.main,
      dark: statusColors.warning.dark,
      darker: statusColors.warning.darker,
      contrastText
    },
    info: {
      lighter: statusColors.info.lighter,
      light: statusColors.info.light,
      main: statusColors.info.main,
      dark: statusColors.info.dark,
      darker: statusColors.info.darker,
      contrastText
    },
    success: {
      lighter: statusColors.success.lighter,
      light: statusColors.success.light,
      main: statusColors.success.main,
      dark: statusColors.success.dark,
      darker: statusColors.success.darker,
      contrastText
    }
  };
};

export default TenantDynamic;
